import Constants from 'config/constants';

export class Format {
	static addSpotToCurbsideLocation(input) {
		if (input.toLowerCase().includes('spot')) {
			return input;
		} else {
			return `Spot ${input}`
		}
	}

	static capitalizeWords(input) {
		if (input != null) {
			return input.toLowerCase()
				.split(' ')
				.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
				.join(' ');
		} else {
			return '';
		}
	}

	static splitStoreHours(input) {
		const times = input.split('-');
		const openHour = times[0].substring(0, 2).replace(/^0+/, '');
		const closeHour = times[1].substring(0, 2).replace(/^0+/, '');
		const openMinutes = times[0].substring(2, 4);
		const closeMinutes = times[1].substring(2, 4);

		if (!openHour || !closeHour) {
			return 'Closed'
		} else {
			return `${openHour > 12 ? `${openHour - 12}:${openMinutes} pm` : `${openHour}:${openMinutes} am`} - 
				${closeHour > 12 ? `${closeHour - 12}:${closeMinutes} pm` : `${closeHour}:${closeMinutes} am`}`
		}
	}

	static getOpenTime(input) {
		const times = input.split('-');
		const openHour = times[0].substring(0, 2).replace(/^0+/, '');
		const openMinutes = times[0].substring(2, 4);

		return `${openHour > 12 ? `${openHour - 12}:${openMinutes} pm` : `${openHour}:${openMinutes} am`}`
	}

	static getClosedTime(input) {
		const times = input.split('-');
		const closeHour = times[1].substring(0, 2).replace(/^0+/, '');
		const closeMinutes = times[1].substring(2, 4);

		return `${closeHour > 12 ? `${closeHour - 12}:${closeMinutes} pm` : `${closeHour}:${closeMinutes} am`}`
	}

	static getOpenHour(input) {
		const times = input.split('-');
		return times[0].substring(0, 2).replace(/^0+/, '');
	}

	static getClosedHour(input) {
		const times = input.split('-');
		return times[1].substring(0, 2).replace(/^0+/, '');
	}

	static getOpenMinute(input) {
		const times = input.split('-');
		return times[0].substring(2, 4).replace(/^0+/, '');
	}

	static getClosedMinute(input) {
		const times = input.split('-');
		return times[1].substring(2, 4).replace(/^0+/, '');
	}

	static isBetweenOpeningHours(h1, m1, h2, m2) {
		const start =  h1 * 60 + m1;
		const end = h2 * 60 + m2;
		const now = new Date();
		const time = now.getHours() * 60 + now.getMinutes();
		return time >= start && time < end;
	}

	static isEligibleForCallStore(input) {
		let minuteThreshold = 1000 * 60 * Constants.CALL_STORE_MINUTE_THRESHOLD;
		return (new Date().getTime() - input.getTime() >= minuteThreshold);
	}
}
